import { useAuthStore } from "@/stores/authStore";

interface SystemMemoPadProps {
  /** BGM 재생 중 여부 */
  isPlaying: boolean;
  /** BGM 토글 */
  toggleBGM: () => void;
  /** 카메라 리셋 */
  onResetCamera?: () => void;
  /** 가장자리 스크롤 활성화 여부 */
  enableEdgeScroll: boolean;
  /** 가장자리 스크롤 토글 */
  setEnableEdgeScroll: (value: boolean) => void;
  /** 숨김 여부 (VN 시나리오 중) */
  isHidden?: boolean;
}


// 메모지 스타일
const MEMO_STYLE: React.CSSProperties = {
  background: "linear-gradient(180deg, #fffef5 0%, #faf5e8 100%)",
  border: "1px solid #d4c9b0",
  borderRadius: "2px",
  boxShadow: "0 2px 6px rgba(0,0,0,0.2)",
  fontFamily: "'Noto Serif KR', serif",
};

/**
 * SystemMemoPad - 인스트럭션 및 설정을 포함한 메모 패드 컴포넌트
 */
export function SystemMemoPad({
  isPlaying,
  toggleBGM,
  onResetCamera,
  enableEdgeScroll,
  setEnableEdgeScroll,
  isHidden,
}: SystemMemoPadProps) {
  const isAnonymous = useAuthStore.getState().isAnonymous();

  if (isHidden) return null;

  return (
    <div style={{ display: "flex", gap: "10px", pointerEvents: "auto" }}>
      {/* 개요 */}
      <div
        style={{
          ...MEMO_STYLE,
          padding: "10px 12px",
          transform: "rotate(-2deg)",
        }}
      >
        <div
          style={{
            fontSize: "13px",
            fontWeight: 700,
            color: "#3a3530",
            fontFamily: "'Space Mono', monospace",
            letterSpacing: "1px",
            marginBottom: "4px",
          }}
        >
          YOURS.ZIP
        </div>
        <div style={{ fontSize: "9px", color: "#777", lineHeight: 1.4 }}>
          {isAnonymous ? "방문자 모드" : "빈 셀 클릭 → 건물 추가"}
        </div>
        <div
          style={{
            marginTop: "6px",
            paddingTop: "5px",
            borderTop: "1px dashed #ccc",
            fontSize: "8px",
            color: "#aaa",
            fontFamily: "'Space Mono', monospace",
          }}
        >
          우클릭: 이동 | 휠: 줌
        </div>
      </div>

      {/* 설정 */}
      <div
        style={{
          ...MEMO_STYLE,
          padding: "10px 12px",
          transform: "rotate(2deg)",
          display: "flex",
          flexDirection: "column",
          gap: "5px",
        }}
      >
        <div style={{ fontSize: "8px", color: "#999", letterSpacing: "1px" }}>
          SETTINGS
        </div>

        {onResetCamera && (
          <button
            onClick={onResetCamera}
            style={{
              padding: "5px 8px",
              fontSize: "9px",
              display: "flex",
              alignItems: "center",
              gap: "5px",
              background: "rgba(0,0,0,0.02)",
              border: "1px solid #d4c9b0",
              borderRadius: "2px",
              cursor: "pointer",
              color: "#666",
            }}
          >
            <span>📍</span>
            <span>원점</span>
          </button>
        )}

        <button
          onClick={toggleBGM}
          style={{
            padding: "5px 8px",
            fontSize: "9px",
            display: "flex",
            alignItems: "center",
            gap: "5px",
            background: isPlaying
              ? "rgba(100,150,100,0.1)"
              : "rgba(0,0,0,0.02)",
            border: "1px solid #d4c9b0",
            borderRadius: "2px",
            cursor: "pointer",
            color: "#666",
          }}
        >
          <span>{isPlaying ? "🔊" : "🔇"}</span>
          <span>BGM</span>
        </button>

        <button
          onClick={() => setEnableEdgeScroll(!enableEdgeScroll)}
          style={{
            padding: "5px 8px",
            fontSize: "9px",
            display: "flex",
            alignItems: "center",
            gap: "5px",
            background: enableEdgeScroll
              ? "rgba(100,150,100,0.1)"
              : "rgba(0,0,0,0.02)",
            border: "1px solid #d4c9b0",
            borderRadius: "2px",
            cursor: "pointer",
            color: "#666",
          }}
        >
          <span>{enableEdgeScroll ? "🖱️" : "🚫"}</span>
          <span>가장자리 스크롤</span>
        </button>
      </div>
    </div>
  );
}
